module.exports = __webpack_public_path__ + "static/media/logo@3x.07bc0f9d.png";